import { Api } from 'components/weblyzard/component-api.js';
import GeoMap from './src/geomap';

const args = (detach, ...param) => {
	return [detach, ...param];
};

export const create = () => {
	var api = new Api(GeoMap);

	api
		// The “in” API
		// These methods can be directly called on this API
		.expose(
			'initialize',
			'colorMode',
			'updateSize',
			'panTo',
			'setMarker',
			'update',
			'updateBubbleSize',
			'getCurrentViewport',
			'setLanguage',
			'setUpdatingState',
			'data',
			'drawPolygons',
			'clearPolygons',
			'drawRect',
			'drawCircle',
			'clearRects',
			'highlightLocations',
			'highlightCountry',
			'dehighlightCountries',
			'highlightBubbles',
			'dehighlightBubbles',
			'toggleArcs',
			'updateArcsType',
			'toggleBubbles',
			'toggleContributors',
			'autozoom',
			'XYtoLonLat',
			'setForcedLegend'
		)
		// The “out” API
		// These events can be subscribed to via the on() method of this API
		.observe(
			'country.mouseover',
			'country.mouseout',
			'country.click',
			'bubble.mouseout',
			'bubble.mousemove',
			'bubble.mouseover',
			'bubble.click',
			'viewport.update', // Coords in form of [lat, lon]
			args
		);

	return api.init();
};
